import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Plus, Search, Zap } from 'lucide-react';

const TagoutList = () => {
  const [tags, setTags] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('/api/tagouts').then(res => setTags(res.data.data || []));
  }, []);

  const filteredData = useMemo(() => tags.filter(t => 
    t.tagoutnum.toLowerCase().includes(searchTerm.toLowerCase()) || (t.description || "").toLowerCase().includes(searchTerm.toLowerCase())
  ), [tags, searchTerm]);

  return (
    <div className="flex flex-col h-full bg-[#f3f4f6] text-[11px] font-sans uppercase font-bold">
      <div className="bg-white p-3 border-b shadow-sm flex justify-between items-center">
        <h2 className="text-[#005495] font-black italic text-lg flex items-center gap-2"><Zap size={20}/> Tag Out Master (LOTO)</h2>
        <div className="flex gap-4">
          <div className="relative"><Search className="absolute left-3 top-2 text-gray-400" size={14} /><input className="pl-9 pr-4 py-1.5 border border-gray-300 w-80 outline-none rounded-sm" placeholder="Search Isolation Points..." value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)}/></div>
          <button onClick={() => navigate('/tagouts/new')} className="bg-[#3c70a4] text-white px-6 py-2 rounded-sm font-black flex items-center gap-2 shadow-md"><Plus size={16}/> NEW TAGOUT</button>
        </div>
      </div>
      <div className="flex-1 overflow-auto p-4">
        <div className="bg-white border shadow-sm">
          <table className="w-full text-left">
            <thead className="bg-[#f9fafb] border-b text-gray-400 font-black sticky top-0">
              <tr><th className="p-2 border-r w-40">Tag Num</th><th className="p-2 border-r">Description</th><th className="p-2 border-r text-center">Req. State</th><th className="p-2 text-center">Site</th></tr>
            </thead>
            <tbody>
              {filteredData.map((t, i) => (
                <tr key={i} className="border-b hover:bg-blue-50 cursor-pointer" onClick={() => navigate(`/tagouts/${t.tagoutnum}`)}>
                  <td className="p-2.5 border-r text-blue-900 font-black uppercase">{t.tagoutnum}</td>
                  <td className="p-2.5 border-r text-gray-600 uppercase">{t.description}</td>
                  <td className="p-2.5 border-r text-center text-red-600 font-black">{t.required_state}</td>
                  <td className="p-2.5 text-center text-gray-400">{t.siteid}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TagoutList;